"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultIfUndefined = exports.hexlifyWithout0xPrefix = exports.convertBytesToNumber = exports.convertIntegerNumberToBytes = exports.convertNumberToBytes = exports.convertStringToBytes32 = exports.assert = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("ethers/lib/utils");
const ZERO_EX_PREFIX_LENGTH = 2;
const assert = (condition, errMsg) => {
    if (!condition) {
        const errText = `Assertion failed` + (errMsg ? `: ${errMsg}` : "");
        throw new Error(errText);
    }
};
exports.assert = assert;
const convertStringToBytes32 = (str) => {
    let bytes32Str;
    if (str.length > 31) {
        bytes32Str = (0, utils_1.keccak256)((0, utils_1.isHexString)(str) ? str : (0, utils_1.toUtf8Bytes)(str));
    }
    else {
        bytes32Str = (0, utils_1.formatBytes32String)(str);
    }
    return (0, utils_1.arrayify)(bytes32Str);
};
exports.convertStringToBytes32 = convertStringToBytes32;
const convertNumberToBytes = (value, decimals, byteSize, roundFractionalComponentIfExceedsDecimals = true) => {
    let stringifiedNumber = roundFractionalComponentIfExceedsDecimals
        ? Number(value).toFixed(decimals)
        : String(value);
    if (stringifiedNumber.includes("e")) {
        stringifiedNumber = Number(stringifiedNumber).toLocaleString("fullwide", {
            useGrouping: false,
        });
    }
    const bigNumberValue = (0, utils_1.parseUnits)(stringifiedNumber, decimals);
    const bytesValue = (0, utils_1.arrayify)(bigNumberValue.toHexString());
    if (byteSize < bytesValue.length) {
        throw new Error(`Overflow: ` +
            `value: ${value}, ` +
            `decimals: ${decimals}, ` +
            `byteSize: ${byteSize}`);
    }
    else {
        return (0, utils_1.zeroPad)(bytesValue, byteSize);
    }
};
exports.convertNumberToBytes = convertNumberToBytes;
const convertIntegerNumberToBytes = (value, byteSize) => {
    (0, exports.assert)(Number.isInteger(Number(value)), "convertIntegerNumberToBytes expects integer as input");
    const decimals = 0;
    return (0, exports.convertNumberToBytes)(value, decimals, byteSize);
};
exports.convertIntegerNumberToBytes = convertIntegerNumberToBytes;
const convertBytesToNumber = (bytes) => ethers_1.BigNumber.from(bytes).toNumber();
exports.convertBytesToNumber = convertBytesToNumber;
const hexlifyWithout0xPrefix = (value) => {
    return (0, utils_1.hexlify)(value).slice(ZERO_EX_PREFIX_LENGTH);
};
exports.hexlifyWithout0xPrefix = hexlifyWithout0xPrefix;
function useDefaultIfUndefined(value, defaultValue) {
    return value === undefined ? defaultValue : value;
}
exports.useDefaultIfUndefined = useDefaultIfUndefined;
//# sourceMappingURL=utils.js.map